import React from 'react';
import { heroImages } from '../data/mock';

export default function About() {
  return (
    <section id="sobre" className="py-24 lg:py-32 border-t border-[color:var(--gold-500)]/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative flex justify-center lg:justify-start">
          <div className="arch-frame w-[300px] md:w-[380px] lg:w-[420px] aspect-[3/4.2]">
            <img
              src={heroImages.about}
              alt="Sobre Ana Rodrigues"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div>
          <p className="text-[10px] md:text-[11px] tracking-widest-2 text-[color:var(--gold-400)] uppercase mb-6">
            Sobre
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.4rem] leading-tight text-[color:var(--cream-100)]">
            Prazer, eu sou{' '}
            <span className="italic text-[color:var(--gold-400)]">Ana Rodrigues.</span>
          </h2>
          <div className="mt-8 space-y-5 text-[color:var(--cream-100)]/80 text-base md:text-lg leading-relaxed max-w-xl">
            <p>
              Sou social media, videomaker e fotógrafa em Belo Horizonte. Há anos
              ajudo marcas e profissionais a traduzirem quem realmente são em
              imagens, vídeos e conteúdo que despertam desejo e confiança.
            </p>
            <p>
              Acredito que redes sociais não são sobre postar todo dia. São
              sobre construir presença, narrativa e autoridade. Cada projeto
              começa com escuta, estratégia e uma boa dose de sensibilidade
              estética.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
